import React from 'react';

const sizeMap = {
  xs: 'w-3 h-3 border-2',
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
  xl: 'w-12 h-12 border-[3px]',
};

const Spinner = ({ size = 'md', className = '', label = 'Loading' }) => (
  <span
    role="status"
    aria-label={label}
    className={`inline-block ${sizeMap[size] || sizeMap.md} border-current border-t-transparent rounded-full animate-spin ${className}`}
  />
);

export default Spinner;
